// extracted by mini-css-extract-plugin
module.exports = {"element":"heading-only_element__2Z79w"};